module.exports = __webpack_public_path__ + "static/media/badge_share_3.8d70dd41.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_share_3.png
// module id = 520
// module chunks = 0